import { Info } from "@aircall/react-icons";

import { Section } from "@/blocks/Section";

import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle";

function WithDrivers() {
  return (
    <Section data-test="predicted-csat-card">
      <div className="flex items-center gap-1">
        <span className="text-base font-semibold">Predicted CSAT</span>
        <Info className="size-4" />
      </div>
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-1">
          <div className="flex size-8 items-center justify-center rounded-full border bg-success-background text-sm font-semibold text-success">
            82
          </div>
          <span className="text-sm font-semibold text-success">High</span>
        </div>
        <span className="text-sm text-muted-foreground">Feedbacks</span>
      </div>
      <div className="flex flex-col gap-1">
        <span className="text-sm font-medium text-success">
          + Issue resolved
        </span>
        <span className="text-sm font-medium text-destructive">
          - Long hold
        </span>
      </div>
    </Section>
  );
}

function WithoutDrivers() {
  return (
    <Section data-test="predicted-csat-card">
      <div className="flex items-center gap-1">
        <span className="text-base font-semibold">Predicted CSAT</span>
        <Info className="size-4" />
      </div>
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-1">
          <div className="flex size-8 items-center justify-center rounded-full border bg-warning-background text-sm font-semibold text-warning">
            52
          </div>
          <span className="text-sm font-semibold text-warning">Medium</span>
        </div>
        <span className="text-sm text-muted-foreground">Feedbacks</span>
      </div>
    </Section>
  );
}

export function PlaygroundSectionCsat() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>With drivers</PlaygroundSubSectionTitle>
        <WithDrivers />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Without drivers</PlaygroundSubSectionTitle>
        <WithoutDrivers />
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
